module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-100.9076f027.jpg";